import { useParams } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { generatePath } from '@/shared/libs/generate-path'
import { useTenantByIdQuery } from '@/entities/tenant'
import { PoiCategoriesConfig } from '@/features/poi'
import { useScopedAdminPath } from '@/shared/hooks/use-scoped-admin-path'
import { PageContainer } from '@/shared/ui/page-container'
import { PageHeader } from '@/shared/ui/page-header'

export function PoiCategoryListPage() {
  const { t } = useTranslation()
  const params = useParams({ strict: false })
  const scopedAdminPath = useScopedAdminPath()
  const tenantId = params.tenantId ?? params.id ?? ''
  const { data: tenantResponse } = useTenantByIdQuery(tenantId)
  const tenantName = tenantResponse?.data?.name ?? tenantId

  return (
    <PageContainer>
      <PageHeader
        title={t('poiCategories.title')}
        breadcrumbs={[
          { label: t('sidebar.tenants'), path: scopedAdminPath('/tenant') },
          ...(tenantName
            ? [
                {
                  label: tenantName,
                  path: scopedAdminPath(generatePath('/tenant/:tenantId', { tenantId })),
                },
              ]
            : []),
          { label: t('poiCategories.title') },
        ]}
      />

      <PoiCategoriesConfig tenantId={tenantId} />
    </PageContainer>
  )
}
